import { DISPUTE_REASON_LABELS, type InvoiceStatusChange } from '@faktorplus/shared';
import { Panel } from '../../components/ui/feedback';
import { StatusPill } from '../../components/ui/status-pill';
import { formatDate } from '../../lib/format';
import pageStyles from '../../components/layout/page.module.css';
import styles from './invoice-detail.module.css';

/** The audit trail as a table: who moved the invoice, to what, and when. */
export function StatusHistory({ entries }: { entries: InvoiceStatusChange[] }) {
  if (entries.length === 0) return null;

  return (
    <Panel title="Historia">
      <div className={pageStyles.tableWrap}>
        <table className={pageStyles.table}>
          <thead>
            <tr>
              <th>Kto</th>
              <th>Status</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td className={pageStyles.strong}>{entry.userName}</td>
                <td>
                  <StatusPill status={entry.toStatus} short />
                  {/* The comment also stands alone, without a dispute reason:
                      an approval made without a handover protocol says so here,
                      and nowhere else once the protocol arrives afterwards. */}
                  {(entry.reason || entry.comment) && (
                    <div className={styles.historyComment}>
                      {entry.reason ? DISPUTE_REASON_LABELS[entry.reason] : ''}
                      {entry.reason && entry.comment ? ' — ' : ''}
                      {entry.comment ? `„${entry.comment}"` : ''}
                    </div>
                  )}
                </td>
                <td className={pageStyles.muted}>{formatDate(entry.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Panel>
  );
}
